import {BlockComponentProps as Props} from 'client-react-block-renderer';
import React, {Component} from 'react';
// import SuggestProductsController from './SuggestedProductsController'

// interface Props extends BlockComponentProps {
//     config: {
//         productCount: number | string
//     }
// }

export default class SuggestedProductsV2Block extends Component<Props> {
    public render() {
        return <div className="alert alert-danger">
            This is version 2 of the suggested products block which has been deprecated and will be removed.
            Please use version 3 instead. Delete this block and drag "Suggested Products V3" onto the page.
        </div>;
        // const instanceConfig = this.props.config;
        // if (typeof instanceConfig.productCount === 'string') {
        //     instanceConfig.productCount = parseInt(instanceConfig.productCount);
        // }
        // return (<SuggestProductsController {...instanceConfig} />)
    }
}
